import { useEffect, useRef, useState } from 'react';
import { useCurrentPage, PageComponentType, useRouter } from 'scbk-services';
import { useCode, useSession, LoginInfo } from 'scbk-shared-module';

/**
 * 개인정보 노출자 체크 HOC
 */
export function withCustInfoLeaked<P extends {}>(Page: PageComponentType<P>): PageComponentType<P> {
  const Wrapped: React.FC<P> = (props: P) => {
    const { getCodes } = useCode(['CSINFOLEAK_BLKMNU']);
    const { getLoginInfo } = useSession();
    const { currentPage: pageInfo } = useCurrentPage();

    const codes = getCodes('CSINFOLEAK_BLKMNU');
    const router = useRouter();
    const [lgnInquirySessionInfo, setLgnInquirySessionInfo] = useState<LoginInfo | undefined>(
      undefined,
    );

    const isFirst = useRef<boolean>(true);
    const custInfoLeakedYn = useRef<boolean>(false); //개인정보 노출 대상자 여부

    const [checkLeaked, setCheckLeaked] = useState<boolean>(true); // 노출체크완료 여부

    const getLoginSessionInfo = async () => {
      const result = await getLoginInfo(['yoLrsotGb']);
      setLgnInquirySessionInfo(result);
    };

    useEffect(() => {
      if (isFirst.current) {
        isFirst.current = false;
        getLoginSessionInfo();
      }
    }, []);

    useEffect(() => {
      const pageId = pageInfo?.id || '';
      if (!isFirst.current && lgnInquirySessionInfo) {
        if (lgnInquirySessionInfo?.yoLrsotGb === '1' && checkLeaked) {
          for (const code of codes) {
            if (pageId?.startsWith(code.code)) {
              custInfoLeakedYn.current = true;
              break;
            }
          }

          setCheckLeaked(false);

          if (custInfoLeakedYn.current) {
            router.push('LGNSET002_10MS', { historyOptions: { clearHistory: true } }); // 개인정보노출 대상자 화면 이동
          }
        } else if (lgnInquirySessionInfo?.yoLrsotGb !== '1' && checkLeaked) {
          setCheckLeaked(false);
        }
        return;
      }
    }, [lgnInquirySessionInfo, pageInfo, codes, checkLeaked]);

    if (checkLeaked) {
      return null;
    } else {
      return <Page {...props} />;
    }
  };

  Wrapped.displayName = `WithCustInfoLeaked(${Page.displayName || Page.name})`;
  return Wrapped;
}
